import Analytics from '@withlocals/withlocals-analytics';
import Modal from 'components/Modal';
import ModalBody from 'components/Modal/ModalBody';
import ModalFooter from 'components/Modal/ModalFooter';
import Paragraph from 'components/Paragraph';
import RoundedButton from 'components/RoundedButton';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const CSS = require('./UnsavedModal.module.scss');

function UnsavedModal({ formName, onSave }) {
  const history = useHistory();
  const location = useLocation<any>();
  const onDiscard = () => {
    Analytics.track(formName, 'Usaved model', 'Discard changes');
    return !location.state?.origin
      ? history.replace('/host/profile/')
      : history.go(-2);
  };

  const onSaveButton = () => {
    Analytics.track(formName, 'Usaved model', 'Save changes');
    onSave();
  };

  const onCloseModal = () => {
    Analytics.track(formName, 'Usaved model', 'Close modal');
    return history.goBack();
  };

  return (
    <Modal show onClose={onCloseModal} className={CSS.Modal}>
      <ModalBody>
        <h1 className={CSS.Title}>Hold on, you have some unsaved changes!</h1>
        <Paragraph>
          Would you like to save your changes before exiting?
        </Paragraph>
      </ModalBody>
      <ModalFooter className={CSS.Footer}>
        <RoundedButton
          className={CSS.Button}
          size="S"
          onClick={onDiscard}
          invertedBorder
        >
          Discard changes
        </RoundedButton>
        <RoundedButton className={CSS.Button} size="S" onClick={onSaveButton}>
          Save changes
        </RoundedButton>
      </ModalFooter>
    </Modal>
  );
}

export default UnsavedModal;
